import { useState } from "react";
import { Modal, Button, TextField } from "@conuti-das/prince-ui";
import { Flex } from "@/ui-prince";
import { useIdentity } from "@/hooks/useIdentity";

export function IdentityModal({
  forceOpen,
  onDismiss,
}: {
  forceOpen?: boolean;
  onDismiss?: () => void;
}) {
  const { name, setName, hasIdentity } = useIdentity();
  const [value, setValue] = useState(name ?? "");
  const [open, setOpen] = useState(forceOpen ?? !hasIdentity);

  function close() {
    setOpen(false);
    onDismiss?.();
  }

  function submit() {
    if (value.trim().length < 2) return;
    setName(value.trim());
    close();
  }

  return (
    <Modal
      isOpen={open}
      title="Anmeldung"
      onOpenChange={(isOpen) => { if (!isOpen) close(); }}
    >
      <div
        style={{
          padding: "var(--s-4)",
          display: "flex",
          flexDirection: "column",
          gap: "var(--s-2)",
        }}
      >
        <p>Wie heißen Sie? (Name + Initialen, nur fürs Audit)</p>
        <TextField
          label="Name"
          value={value}
          onChange={setValue}
          placeholder="z.B. Maria S."
        />
      </div>
      <Flex justifyContent="End" style={{ marginTop: "var(--s-3)" }}>
        <Button
          variant="filled"
          onPress={submit}
          isDisabled={value.trim().length < 2}
        >
          Speichern
        </Button>
      </Flex>
    </Modal>
  );
}
